var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block text-normal font-medium leading-5 text-gray-700",attrs:{"for":_vm.labelFor}},[_vm._t("default"),_vm._v(" "),(_vm.required)?_c('span',{staticClass:"text-xs text-red-400"},[_vm._v("●")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }